/* global axios */
import ApiClient from '../ApiClient';

class ArrowsAiFaqsAPI extends ApiClient {
  constructor() {
    super('arrows_ai/assistants', { accountScoped: true });
  }

  get({ assistantId } = {}) {
    return axios.get(`${this.url}/${assistantId}/faqs`);
  }

  create({ assistantId, question, answer } = {}) {
    return axios.post(`${this.url}/${assistantId}/faqs`, {
      faq: { question, answer },
    });
  }

  update({ assistantId, id, question, answer } = {}) {
    return axios.patch(`${this.url}/${assistantId}/faqs/${id}`, {
      faq: { question, answer },
    });
  }

  delete({ assistantId, id } = {}) {
    return axios.delete(`${this.url}/${assistantId}/faqs/${id}`);
  }

  import({ assistantId, file } = {}) {
    const body = new FormData();
    body.append('file', file);
    return axios.post(`${this.url}/${assistantId}/faqs/import`, body);
  }
}

export default new ArrowsAiFaqsAPI();
